import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div<{ isOpen: boolean }>(
  ({ isOpen }) => `
  background: var(--right-panel-background-color);
  border-left: 1px solid var(--right-panel-border-left-color);
  color: var(--right-panel-color);
  display: flex;
  font-size: ${rem(14)};
  flex-direction: column;
  grid-area: e;
  opacity: ${isOpen ? 1 : 0};
  overflow: hidden auto;
  overscroll-behavior: none;
  scale: ${isOpen ? 1 : 0};
  transition: opacity 0.25s ease-in-out;
  width: ${isOpen ? 'var(--sources-panel-width)' : 0};

  && {
    // Keep the width intact to avoid breaking the layout
    scrollbar-gutter: initial;
  }

  @media (max-width: 1440px) {
    width: 375px;
  }

  @media (max-width: 768px) {
    border-left: none;
    height: 100dvh;
    opacity: 1;
    position: fixed;
    right: 0;
    top: 0;
    transform: translate3d(${isOpen ? 0 : 100}%, 0, 0);
    transition: transform 250ms ease-in-out, scale 0ms ${isOpen ? 0 : 250}ms;
    width: 100vw;
    will-change: transform;
    z-index: 5;
  }
`
);

const Header = styled.header(
  ({ theme }) => `
  background: ${theme.palette.common.white};
  border-bottom: 1px solid ${theme.palette.grey[200]};
   color: inherit;
  display: flex;
  height: var(--action-panel-height);
  justify-content: space-between;
  align-items: center;
  flex-flow: row wrap;
  gap: ${rem(16)} ${rem(8)};
  position: sticky;
  padding: ${rem(16)} ${rem(24)};
  top: 0;
  z-index: 2;

  @media (max-width: 768px) {
    border-bottom: none;
    height: auto;
    justify-content: center;
    padding: ${rem(16)};
    transition: box-shadow 100ms ease;

    &.shadow {
      box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.08);
    }
  }
`
);

const Title = styled.h3`
  color: inherit;
  font-size: ${rem(20)};
  font-weight: 600;
  line-height: ${rem(32)};
  margin-bottom: 0;

  @media (max-width: 768px) {
    flex-grow: 1;
    order: 2;
    text-align: center;
    margin-left: ${rem(-40)};
  }

  @media (max-width: 768px) {
    font-size: ${rem(16)};
    font-weight: 600;
    line-height: ${rem(24)};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${rem(24)};
  row-gap: ${rem(24)};

  @media (max-width: 430px) {
    padding: ${rem(16)};
    row-gap: ${rem(16)};
  }
`;

const Subtitle = styled.h4`
  color: inherit;
  display: none;
  font-size: ${rem(16)};
  font-weight: 400;
  line-height: ${rem(24)};
  order: 3;
  padding: 0 ${rem(4)};
  width: 100%;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem(392)};
  padding: ${rem(24)};
`;

const CloseButton = styled.button(
  ({ theme }) => `
  background: none;
  border: none;
  border-radius: 4px;
  box-sizing: content-box;
  color: inherit;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(24)};
  height: ${rem(24)};
  transition: 100ms ease;

  .close {
    width: ${rem(14)};
    height: ${rem(14)};
  }

  .back {
    display: none;
    width: ${rem(16)};
    height: ${rem(16)};
  }

  &:hover {
    color: ${theme.palette.primary.main};
  }

  &:active {
    background: ${theme.palette.primary.dark};
    color: ${theme.palette.common.white};
  }

  @media (max-width: 768px) {
    order: 1;
    z-index: 1;

    .back {
      display: block;
    }

    .close {
      display: none;
    }
  }
`
);

export default {
  Wrapper,
  CloseButton,
  Content,
  Loader,
  Header,
  Title,
  Subtitle
};
